/* global document */

import ReactDOM from 'react-dom';

// eslint-disable-next-line import/no-cycle
import Widget from './jordanLoyaltyWidget/JordanLoyaltyWidget';

const JordanLoyaltyWidget = () =>
  ReactDOM.createPortal(
    <>
      <Widget />
    </>,
    document.getElementById('c7-loyalty-widget-jv')
  );

export default JordanLoyaltyWidget;
